module.exports = __webpack_public_path__ + "img/icon-competencies.9d59dc1e.svg";